import { render, staticRenderFns } from "./Indicators.vue?vue&type=template&id=b832aede&"
import script from "./Indicators.ts?vue&type=script&lang=ts&"
export * from "./Indicators.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports